var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "field" },
      [
        _c("label", [_vm._v("AFメモ")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.model.concierge_memo,
              expression: "form.model.concierge_memo",
            },
          ],
          domProps: { value: _vm.form.model.concierge_memo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form.model, "concierge_memo", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("validation-message", {
          attrs: { form: _vm.form, field: "concierge_memo" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "fields" }, [
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("ステータス")]),
          _vm._v(" "),
          _c("div", { staticClass: "fields" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_public,
                      expression: "form.model.is_public",
                    },
                  ],
                  attrs: { type: "radio", name: "is_publick" },
                  domProps: {
                    value: "true",
                    checked: _vm._q(_vm.form.model.is_public, "true"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_public", "true")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("公開")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_public,
                      expression: "form.model.is_public",
                    },
                  ],
                  attrs: { type: "radio", name: "is_publick" },
                  domProps: {
                    value: "false",
                    checked: _vm._q(_vm.form.model.is_public, "false"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_public", "false")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("非公開")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "is_public" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("ランク")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fields" },
            _vm._l(_vm.consts.SHOP_RANK, function (rank) {
              return _c("div", { key: rank.value, staticClass: "field" }, [
                _c("div", { staticClass: "ui checkbox radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.rank,
                        expression: "form.model.rank",
                      },
                    ],
                    attrs: { type: "radio", name: "rank" },
                    domProps: {
                      value: rank.value,
                      checked: _vm._q(_vm.form.model.rank, rank.value),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.form.model, "rank", rank.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(_vm._s(rank.label))]),
                ]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "rank" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("コンシェルジュのおすすめ店舗に表示")]),
          _vm._v(" "),
          _c("div", { staticClass: "fields" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_recommended,
                      expression: "form.model.is_recommended",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    name: "is_recommended",
                    value: "true",
                  },
                  domProps: {
                    checked: _vm._q(_vm.form.model.is_recommended, "true"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_recommended", "true")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("表示する")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_recommended,
                      expression: "form.model.is_recommended",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    name: "is_recommended",
                    value: "false",
                  },
                  domProps: {
                    checked: _vm._q(_vm.form.model.is_recommended, "false"),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_recommended", "false")
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("表示しない")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "is_recommended" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("上位PR")]),
          _vm._v(" "),
          _c("div", { staticClass: "fields" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_promotion,
                      expression: "form.model.is_promotion",
                    },
                  ],
                  attrs: { type: "radio", name: "is_promotion" },
                  domProps: {
                    value: true,
                    checked: _vm._q(_vm.form.model.is_promotion, true),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_promotion", true)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("表示する")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "ui checkbox radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.is_promotion,
                      expression: "form.model.is_promotion",
                    },
                  ],
                  attrs: { type: "radio", name: "is_promotion" },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.form.model.is_promotion, false),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form.model, "is_promotion", false)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", [_vm._v("表示しない")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "is_promotion" },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fields" }, [
      _c(
        "div",
        { staticClass: "four wide field" },
        [
          _c("label", [_vm._v("請求対象")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.billing_subject,
                expression: "form.model.billing_subject",
              },
            ],
            attrs: { type: "text", placeholder: "税込総額" },
            domProps: { value: _vm.form.model.billing_subject },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "billing_subject", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "billing_subject" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required four wide field" },
        [
          _c("label", [_vm._v("手数料率")]),
          _vm._v(" "),
          _c("div", { staticClass: "ui right labeled input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.charge_rate,
                  expression: "form.model.charge_rate",
                },
              ],
              attrs: { type: "number", placeholder: "10" },
              domProps: { value: _vm.form.model.charge_rate },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "charge_rate", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "ui label" }, [_vm._v("%")]),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "charge_rate" },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fields" }, [
      _c(
        "div",
        { staticClass: "eight wide field" },
        [
          _c("label", [_vm._v("グループ")]),
          _vm._v(" "),
          _c(
            "dropdown",
            {
              attrs: { placeholder: "グループ" },
              model: {
                value: _vm.form.model.group,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "group", $$v)
                },
                expression: "form.model.group",
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("なし")]),
              _vm._v(" "),
              _vm._l(_vm.groups, function (group) {
                return _c(
                  "option",
                  { key: group.id, domProps: { value: group.id } },
                  [_vm._v(_vm._s(group.name))]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "eight wide field" }, [
        _c("label", [_vm._v("企業名")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.model.company_name,
              expression: "form.model.company_name",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.form.model.company_name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form.model, "company_name", $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }